import { validateInputs } from 'shared/lib';
import { SignUpErrors } from 'shared/consts/sign-up.error';

export const validateEditProfileInfo = (
  fullName: string,
  email: string,
  phone: string
) => {
  // Валидация ФИО
  if (!validateInputs.validateFullName(fullName)) {
    return SignUpErrors.INCORRECT_FULL_NAME;
  }

  // Валидация email
  else if (!validateInputs.validateMail(email)) {
    return SignUpErrors.INCORRECT_EMAIL;
  }

  // Валидация телефона
  else if (!validateInputs.validatePhone(phone)) {
    return SignUpErrors.INCORRECT_PHONE;
  } else {
    return SignUpErrors.NO_ERRORS;
  }
};
